const { formatMoney } = window.BAO.Utils
class AddHoops extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()
  }

  setupListeners () {
    this.handleOptionChange = this.handleOptionChange.bind(this)

    this.els.option?.elements.forEach((optionEl) => {
      this.listeners.add(optionEl, 'change', this.handleOptionChange)
    })

    this.addToCart = this.addToCart.bind(this)
    this.listeners.add(window, 'productAddedToCart', this.addToCart)
  }

  handleOptionChange (event) {
    const optionEl = event.target

    this.els.option?.elements.forEach((allOptionEl) => {
      if (optionEl !== allOptionEl) {
        allOptionEl.checked = false
      }
    })

    if (optionEl.checked) {
      const productId = optionEl.getAttribute('data-add-hoops-product-id')
      const variantId = optionEl.getAttribute('data-add-hoops-variant-id')
      const optionPrice = optionEl.getAttribute('data-add-hoops-price')
      const optionTitle = optionEl.getAttribute('data-title')
      const optionName = optionEl.getAttribute('data-name')

      this.els.formVariantId.element.value = variantId
      this.els.formLastSelectedProductId.element.value = productId
      this.els.formProductId.element.value = productId

      if (this.isQuickBuy) {
        this.handleQuickBuyOptionSelect(optionTitle)
      } else {
        this.handleDefaultOptionSelect(optionPrice, productId, optionName)
      }
    } else {
      this.els.formVariantId.element.value = ''
      this.els.formLastSelectedProductId.element.value = ''
      this.els.formProductId.element.value = ''

      if (this.isQuickBuy) {
        this.unselectOptionQuickBuy()
      } else {
        this.unselectOptionProductForm()
      }
    }
  }

  unselectOptionQuickBuy () {
    window.drawers.activeDrawerKey = 'drawer-quick-buy'

    const selectedTextEl = document.querySelector(
      this.quickBuySelectedTextSelector,
    )

    if (selectedTextEl) {
      selectedTextEl.textContent = selectedTextEl.getAttribute('data-text')
      selectedTextEl.classList.add(this.inputUnselectedClass)
    }
  }

  unselectOptionProductForm () {
    setTimeout(() => {
      document.querySelector('site-drawers')?.closeDrawer()
    }, 300)

    const selectedPriceEl = document.querySelector(
      this.productFormSelectedPriceSelector,
    )

    if (selectedPriceEl) {
      selectedPriceEl.textContent = ''
    }

    const selectedTitleEl = document.querySelector(
      this.productFormSelectedTextSelector,
    )

    if (selectedTitleEl) {
      selectedTitleEl.textContent = selectedTitleEl.getAttribute('data-text')
      selectedTitleEl.classList.remove(this.productFormSelectedClass)
    }

    if (this.externalEls['product-form-image-input']) {
      this.externalEls['product-form-image-input'].elements.forEach(
        (element) => {
          element.value = ''
        },
      )
    }

    this.updatePrice(0)
  }

  handleDefaultOptionSelect (optionPrice, productId, optionName) {
    setTimeout(() => {
      document.querySelector('site-drawers')?.closeDrawer()
    }, 300)

    const selectedPriceEl = document.querySelector(
      this.productFormSelectedPriceSelector,
    )

    if (selectedPriceEl) {
      selectedPriceEl.textContent = `+${formatMoney(optionPrice)}`
    }

    const selectedTitleEl = document.querySelector(
      this.productFormSelectedTextSelector,
    )

    if (selectedTitleEl) {
      selectedTitleEl.textContent = optionName
      selectedTitleEl.classList.add(this.productFormSelectedClass)
    }

    this.updateMedia(productId)
    this.updatePrice(optionPrice)
  }

  handleQuickBuyOptionSelect (optionTitle) {
    window.drawers.activeDrawerKey = 'drawer-quick-buy'

    const selectedTextEl = document.querySelector(
      this.quickBuySelectedTextSelector,
    )

    if (selectedTextEl) {
      selectedTextEl.textContent = optionTitle
      selectedTextEl.classList.remove(this.inputUnselectedClass)
    }
  }

  updateMedia (productId) {
    let imageEl
    imageEl = document.querySelector(
      `[data-add-hoops-external-el="product-image"][data-hoop="${productId}"]`,
    )
    if (!imageEl) {
      imageEl = document.querySelector(
        `[data-add-hoops-external-el="product-image"][data-hoop]`,
      )
    }

    if (this.externalEls['product-form-image-input'] && imageEl) {
      this.externalEls['product-form-image-input'].elements.forEach(
        (element) => {
          element.value = imageEl.dataset.image
        },
      )
    }

    const mediaEl = document.querySelector('product-media')

    if (mediaEl && imageEl) {
      mediaEl.moveToIdx(imageEl.dataset.index)
    }
  }

  updatePrice (optionPrice) {
    this.externalEls.price?.elements.forEach((priceEl) => {
      const currentPrice = parseInt(priceEl.dataset.price)
      const combinedPrice = currentPrice + parseInt(optionPrice)

      priceEl.setAttribute('data-add-hoops-price', optionPrice)
      priceEl.textContent = formatMoney(combinedPrice)
    })

    this.externalEls.personalisationPrice?.elements.forEach((element) => {
      element.setAttribute('data-add-hoops-price', optionPrice)
    })
  }

  addToCart (event) {
    const formId = event?.detail?.formId

    if (this.isMatchingFormId(formId) !== true) return

    const variantId = this.els.formVariantId.element.value
    // Only add hoops to cart if a hoop variant has been selected
    if (!variantId || variantId === '') {
      return Promise.resolve()
    }

    this.els.formParentKey.element.value = event.detail.item.key

    return window.BAO.Cart.addItemFromForm(this.els.form.element)
  }

  isMatchingFormId (formId) {
    const currentFormId = this.dataset.formId

    if (this.isQuickBuy === true) {
      // If the item is quickbuy, we check the full form IDs in the comparison
      return formId === currentFormId
    } else {
      // However, if the context is the a PDP form, we remove the product ID
      // from the end of the form ID before checking, as the PDP can have a
      // regular form and a personalisation form, both of which are appended.
      const stripLastSegment = (str) => str?.substring(0, str.lastIndexOf('-'))

      return stripLastSegment(formId) === stripLastSegment(currentFormId)
    }
  }

  get isQuickBuy () {
    return this.dataset.context === 'quick-buy'
  }

  get inputUnselectedClass () {
    return `qb-Form_VariantText-light`
  }

  get quickBuySelectedTextSelector () {
    return `[data-product-hoops-external-el="quickbuy-selected-text"]`
  }

  get productFormSelectedTextSelector () {
    return `[data-product-hoops-external-el="product-form-selected-text"]`
  }

  get productFormSelectedPriceSelector () {
    return `[data-product-hoops-external-el="product-form-selected-price"]`
  }

  get productFormSelectedClass () {
    return `prd-Form_VariantText-dark`
  }
}

if (!customElements.get('add-hoops')) {
  customElements.define('add-hoops', AddHoops)
}
